'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var convertHelper = require('../../types/convertHelper');
var arrowHelper = require('../../helper/arrowHelper');
var graphicsHelper = require('../../helper/graphicsHelper');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var util = require('../../helper/util');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 线段组件
 */
var Line = React.createClass({

  componentWillUnmount: function () {
    if (this.requestID) {
      cancelAnimationFrame(this.requestID);
    }
  },

  paint: function () {
    var _this = this;
    var startPoint;
    var endPoint;
    var controlPoint;
    var arrowLeftPoints;
    var arrowRightPoints;
    var thickness;
    var ratio = 1;
    var w;
    var h;
    var p;
    var dash = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
    startPoint = util.Point.strToPoint(this.props.startPoint);
    endPoint = util.Point.strToPoint(this.props.endPoint);
    controlPoint = util.Point.strToPoint(this.props.controlPoint);
    //thickness = styleHelper.getPropertyValue(_this.props,propConst.THICKNESS);

    //util.Point.offset(startPoint,Math.round(startPoint.x) - startPoint.x + thickness/2,Math.round(startPoint.y) - startPoint.y + thickness/2);
    //util.Point.offset(endPoint,Math.round(endPoint.x) - endPoint.x + thickness/2,Math.round(endPoint.y) - endPoint.y + thickness/2);

    util.Path.Curve.create(startPoint, endPoint, controlPoint);

    if (this.props.showStartArrow) {
      arrowLeftPoints = arrowHelper.getArrowPoint(controlPoint, startPoint, 0.5, 10);
    }

    if (this.props.showEndArrow) {
      arrowRightPoints = arrowHelper.getArrowPoint(controlPoint, endPoint, 0.5, 10);
    }
    if (this.canChange) {
      this.requestID = window.requestAnimationFrame(function () {
        var canvas = ReactDOM.findDOMNode(_this.refs.canvas);
        if (!canvas) {
          return;
        }
        var ctx = canvas.getContext('2d');

        w = styleHelper.getWidth(_this.props);
        h = styleHelper.getHeight(_this.props);
        ratio = graphicsHelper.applyDeviceRatio(ctx,w,h);
        w *= ratio;
        h *= ratio;
        util.Point.scale(startPoint,ratio);
        util.Point.scale(controlPoint,ratio);
        util.Point.scale(endPoint,ratio);
        if(arrowLeftPoints) {
          util.Point.scale(arrowLeftPoints.left, ratio);
          util.Point.scale(arrowLeftPoints.right, ratio);
        }
        if(arrowRightPoints){
          util.Point.scale(arrowRightPoints.left,ratio);
          util.Point.scale(arrowRightPoints.right,ratio);
        }

        //startPoint.x = startPoint.x * ratio;
        //startPoint.y = startPoint.y * ratio;
        //controlPoint.x = controlPoint.x * ratio;
        //controlPoint.y = controlPoint.y * ratio;
        //endPoint.x = endPoint.x * ratio;
        //endPoint.y = endPoint.y * ratio;
        thickness = styleHelper.getPropertyValue(_this.props, propConst.THICKNESS);

        //ctx.clearRect(0, 0, styleHelper.getWidth(_this.props), styleHelper.getHeight(_this.props));
        graphicsHelper.clearRect(ctx);
        graphicsHelper.initContextStyle(ctx, thickness, (styleHelper.getBackgroundColor(_this.props)), undefined, dash);
        //ctx.lineCap = 'butt';
        if (_this.props.isCurved) {
          graphicsHelper.drawCurveLine(ctx, startPoint.x, startPoint.y, endPoint.x, endPoint.y);
        } else {
          graphicsHelper.drawCurveLine(ctx, startPoint.x, startPoint.y, endPoint.x, endPoint.y, controlPoint.x, controlPoint.y);
        }
        ctx.stroke();
        ctx.beginPath();
        graphicsHelper.setDash(ctx);

        //ctx.beginPath();
        if (parseInt(_this.props.showStartArrow, 10)) {
          ctx.moveTo(arrowLeftPoints.left.x, arrowLeftPoints.left.y);
          ctx.lineTo(startPoint.x, startPoint.y);
          ctx.lineTo(arrowLeftPoints.right.x, arrowLeftPoints.right.y);

        }

        if (parseInt(_this.props.showEndArrow, 10)) {
          ctx.moveTo(arrowRightPoints.left.x, arrowRightPoints.left.y);
          ctx.lineTo(endPoint.x, endPoint.y);
          ctx.lineTo(arrowRightPoints.right.x, arrowRightPoints.right.y);
        }

        ctx.stroke();
      });
    }
  },

  componentDidMount: function () {
    this.paint();
  },

  componentDidUpdate: function () {
    this.paint();
  },

  componentWillReceiveProps: function (newProps) {
    //此处不明作用，猜测是为提升性能比较数据
    //将其注释掉为解决线条切换页面后再切换回来不显示问题
    //this.canChange = JSON.stringify(this.props) !== JSON.stringify(newProps);
    this.canChange = true;
  },

  canChange: true,

  getCurveCenterPoint: function () {
    var startPoint = util.Point.strToPoint(this.props.startPoint);
    var endPoint = util.Point.strToPoint(this.props.endPoint);
    var controlPoint = util.Point.strToPoint(this.props.controlPoint);

    var i;
    var T = 0;
    var N = 3000;
    var px;
    var py;
    this.getPointsOnLine();
    if (!this.props.isTextPosCenter) {
      return this.points[0];
    } else {
      return this.points[this.points.length / 2];
    }
  },

  getPointsOnLine: function () {
    var startPoint = util.Point.strToPoint(this.props.startPoint);
    var endPoint = util.Point.strToPoint(this.props.endPoint);
    var controlPoint = util.Point.strToPoint(this.props.controlPoint);

    var i;
    var T = 0;
    var N = 300;
    var S = 1 / N;
    var px;
    var py;
    this.points = [];
    for (i = 0; i < N; i++) {
      px = Math.pow(1 - T, 2) * startPoint.x + 2 * T * (1 - T) * controlPoint.x + Math.pow(T, 2) * endPoint.x;
      py = Math.pow(1 - T, 2) * startPoint.y + 2 * T * (1 - T) * controlPoint.y + Math.pow(T, 2) * endPoint.y;
      T += S;
      this.points.push({x: px, y: py});
    }
  },

  render: function () {
    var curvePoint = this.getCurveCenterPoint();

    var isMultiLineText;
    var textArray;
    var divStyle;
    var pStyle;
    var size = styleHelper.getSize(this.props);
    var text = styleHelper.getText(this.props);

    if (text) {
      textArray = util.Text.delimitToParagraphs(text);
      isMultiLineText = textArray.length > 1;
    }

    divStyle = {
      left: Math.round(curvePoint.x),
      top: Math.round(curvePoint.y),
      borderColor: styleHelper.getPropertyValue(this.props, propConst.TEXT_BORDER_COLOR),
      backgroundColor: styleHelper.getPropertyValue(this.props, propConst.TEXT_BACKGROUND_COLOR),
      color: styleHelper.getTextColor(this.props),
      fontSize: styleHelper.getFontSize(this.props)
    };

    pStyle = {
      textAlign: convertHelper.getTextHorizontalAlign(this.props.textAlign)
    };

    return (
      <div className="component-Line">
        <canvas
          ref="canvas"
          onClick={this.onClick}
          onMouseEnter={this.onMouseEnter}
          onMouseDown={this.onMouseDown}
          style={{width:'100%',height:'100%'}}
          width={size.width}
          height={size.height}
        />
        {text &&
        <div style={divStyle} className="text">
          {
            !isMultiLineText &&
            <label>
              {text}
            </label>
          }
          {
            isMultiLineText &&
            textArray.map(function (text, idx) {
              if (text.trim()) {
                return (<p key={idx} style={pStyle}>{text}</p>);
              }
              return <br key={idx}/>;
            })
          }
        </div>}
      </div>
    );
  },

  checkValidPoint(e){
    var x = e.nativeEvent.layerX;
    var y = e.nativeEvent.layerY;
    return util.Path.Curve.isPointIn(x, y, 10);
  },

  onMouseDown: function (e) {
    if (!this.checkValidPoint(e)) {
      e.stopPropagation();
    }
  },
  onMouseUp: function (e) {

  },

  onMouseEnter: function (e) {
    if (!this.checkValidPoint(e)) {
      e.bubbles = false;
      e.stopPropagation();
      e.cancelBubble = true;
      e.nativeEvent.stopPropagation();
    }
  },
  onMouseLeave: function () {
  },

  onClick: function (e) {
    if (!this.checkValidPoint(e)) {
      e.stopPropagation();
    }
  }
});

module.exports = Line;



// WEBPACK FOOTER //
// ./src/views/Components/Line.jsx